import { InjectionToken } from '@angular/core';

import type { Observable } from 'rxjs';

import type { OfferScope } from '@core/offers-data';
import type { TOfferStatus } from '@core/offers-types';
import type { RequisitionsScope } from '@core/requisitions-types';
import type { IconName } from '@core/user-interface-legacy';
import type { ViewType } from '@recruitee/search-types';

export interface BulkItemBase {
  id: number;
}

export interface CandidateBulkItem extends BulkItemBase {
  isAnonymous?: boolean;
  isHired?: boolean;
  emails: string[];
  name: string;
  createdAt?: string;
  placements?: Array<{
    id: number;
    disqualifyReason: string;
    offer: { id: number };
    ratingVisible: boolean;
    stage?: {
      id: number;
    };
    candidateId: number;
  }>;
}

export enum BulkActionType {
  AddWorkLocations,
  AddSources,
  AddTags,
  AddTask,
  Archive,
  Assign,
  Unassign,
  Disqualify,
  Requalify,
  SendEEO,
  SendMail,
  Share,
  ChangeStage,
  Delete,
  Extend,
  Follow,
  Unfollow,
  ManageReferrals,
  Retrieve,
  ManageEeo,
  DeleteArchived,
  RetrieveArchived,
  Merge,
  Submit,
  Withdraw,
}

export interface BulkAction {
  id: BulkActionType;
  buttonLabel?: string;
  buttonIcon?: IconName;
  analytics?: string | (() => void);
  analyticsWithPayload?: (payload: unknown) => void;
  isNew?: boolean;
}

export type GetBulkActionsProps =
  | {
      offer?: { kind: 'job' | 'talent_pool'; status: TOfferStatus };
      offersScope?: OfferScope;
      requisitionsScope?: RequisitionsScope;
    }
  | undefined;

export type BulkSelectionTrackerItemFilter = <T extends BulkItemBase = BulkItemBase>(
  items: T[],
) => Observable<T[]>;
export const BULK_SELECTION_TRACKER_ITEM_FILTER: InjectionToken<BulkSelectionTrackerItemFilter> =
  new InjectionToken('BULK_SELECTION_TRACKER_ITEM_FILTER');

export type BulkActionsContext =
  | {
      offer?: { kind: 'job' | 'talent_pool'; id: number; status: TOfferStatus };
      offersScope?: OfferScope;
      searchViewType?: ViewType;
    }
  | undefined;
